import type { DashboardQuery } from "src/graphql";
import type * as analytics from "src/lib/analytics";
import type { CohortFilter as AnalyticsCohortFilter } from "@hightouch/lib/query/visual/types";

export type DashboardData = NonNullable<DashboardQuery["dashboards_by_pk"]>;

export type LookbackWindow = RelativeTimeWindow | AbsoluteTimeWindow | null;

export type RelativeTimeWindow = {
  lookback: number; // seconds
};

export type AbsoluteTimeWindow = {
  start: string; // Datetime ISO
  end: string; // Datetime ISO
};

export const isDefaultLookbackWindow = (data: any): data is null => {
  return data === null;
};

export const isRelativeTimeWindow = (data: any): data is RelativeTimeWindow => {
  return data != null && typeof data.lookback === "number";
};

export const isAbsoluteTimeWindow = (data: any): data is AbsoluteTimeWindow => {
  return data != null && "start" in data && "end" in data;
};

export enum LookbackWindowOption {
  Default = "default",
  SevenDays = "7-days",
  ThirtyDays = "30-days",
  SixtyDays = "60-days",
  NinetyDays = "90-days",
}

export type CohortFilter = AnalyticsCohortFilter | null;

export type DashboardTrackingData = {
  workspace_id: any | undefined;
  id: string;
  total_charts: number | undefined;
  parent_model_id: number | undefined;
  parent_model_name: string | undefined;
  parent_model_connection: string | undefined;
} & analytics.Data;
